<template>
  <div class="chart_container">
    <h4 id="chart_title">Quelques {{titre_chiffre}} sites ont été mis en ligne {{ titre_texte }}</h4>
    <highcharts class="hc" ref='monChart' :options="chartOptions" ></highcharts>
    <p>Ce graphique a été mis à jour automatiquement le {{ this.$store.state.date }}</p>
</div>
</template>

<script>

export default {
  props : {
    highlightYear: Number
    },
  data() {
    const _self = this
    return {
      titre_chiffre: 1000,
      titre_texte: "depuis 2010",
      chartOptions: {
        chart: {
          type: "areaspline",
        },
        title: {
          text: ""
        },
        legend: {
          enabled: false,
          layout: "vertical",
          align: "left",
          verticalAlign: "top",
          x: 0,
          y: 100,
          floating: true,
          borderWidth: 1,
          backgroundColor: "#FFFFFF"
        },
        xAxis: {
          categories: [
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022"
          ],
          plotBands: [
          {

            from: 2010,
            to: 2010,
            color: "rgba(68, 170, 213, .2)"
          }
        ],
        },
        yAxis: {
          title: {
            text: "Nombre de sites"
          }
        },
        tooltip: {
          shared: true,
          valueSuffix: " sites"
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          series: {
            point: {
              events: {
                mouseOver: function () {
                  console.log('point', _self.x, _self.y)
                  _self.titre_texte = "en " + this.x
                  _self.titre_chiffre = this.y
                },
                mouseOut: function () {
                  _self.titre_texte = "depuis 2010"
                  _self.titre_chiffre = _self.$store.getters.total_site
                }
              }
            },
            states:{
              hover:{
                halo:{
                  opacity:0.25,
                  size:30,
                  attributes: {
                    fill: '#FFAE4F',
                    strokeWidth:2,
                    stroke: '#FFAE4F'
                  }

                },
              },
              select:{
                halo:{
                  opacity:0.25,
                  size:30,
                  attributes: {
                    fill: '#FFAE4F',
                    strokeWidth:2,
                    stroke: '#FFAE4F'
                  }

                }
              }
            }
          },
          areaspline: {
           fillOpacity: 0.3,
           }
        },
        series: [
          {
            name: 'les sites frauduleux',
            data: [],
           allowPointSelect: true,

          }
        ]
      }
    };

  },
  created() {
    this.$store.dispatch("loadYears")
    },
  mounted() {
    const _self = this;
    setTimeout(function () {
      _self.$refs['monChart'].chart.series[0].setData(_self.$store.state.year_graph)
      _self.titre_chiffre = _self.$store.getters.total_site

    }, 1500)

  },
  watch:{
    highlightYear(selectedYear){
      console.log("---------HIGHLIGHT YEAR -------")
      var indexSelectedYear = (selectedYear - 2010)
      this.$refs['monChart'].chart.series[0].data[indexSelectedYear].setState('hover')
      }

  }

}



</script>

<style>
.chart_container{
  position:relative;
  top:10vh;
  width:100vw;
  display:flex;
  flex-direction:column;

}

.hc{
  width:100%;
  height:50%;
}


#chart_title{
  text-align: center;
}


@media screen and (max-width:1000px) and (min-width:601px){
  .chart_container{
    position:relative;
    top:0px;
    width:70vw;
    display:flex;
    flex-direction:column;
    flex-shrink: 0;

  }

  .hc{
    width:100%;
    height:100%;
  }


  #chart_title{
    text-align: center;
  }
}








@media screen and (max-width:600px){
  .chart_container{
    position:relative;
    top:0px;
    width:100vw;
    display:flex;
    flex-direction:column;

  }

  .hc{
    width:100vw;
    height:auto;
  }


  #chart_title{
    text-align: center;
  }
}
</style>